import React from "react"
import { graphql } from "gatsby"
import Layout from "../../components/Layout/layout"
import ResultsTaxo from "../../components/ResultsTaxo/results-taxo"
import PropTypes from "prop-types"
import SEO from "../../components/seo"

//-----------------------QueryGraphql---------------------------//

export const query = graphql`
  query($slugTerm: String!) {
    allNodeCarnetDAdresse(
      sort: { fields: field_ordre_carnet_d_adresse }
      filter: {
        relationships: {
          field_taxonomie_thematique: { elemMatch: { name: { eq: $slugTerm } } }
        }
      }
    ) {
      ...ListAdresses
    }
    allNodeActualites(
      sort: { fields: created }
      filter: {
        relationships: {
          field_taxonomie_thematique: { elemMatch: { name: { eq: $slugTerm } } }
        }
      }
    ) {
      ...TaxoThematiqueActu
    }
    allNodeEvenements(
      sort: { fields: created }
      filter: {
        relationships: {
          field_taxonomie_thematique: { elemMatch: { name: { eq: $slugTerm } } }
        }
      }
    ) {
      ...TaxoThematiqueEvents
    }
    allNodePage(
      sort: { fields: created }
      filter: {
        relationships: {
          field_taxonomie_thematique: { elemMatch: { name: { eq: $slugTerm } } }
        }
      }
    ) {
      ...TaxoThematiquePage
    }
  }
`
//-----------------------QueryGraphql---------------------------//

//-----------------------Component---------------------------//

const TaxoThematiquesTemplate = ({ data, pageContext }) => {
  const { skip, limit, slugTerm } = pageContext
  const mergedNodes = [
    ...data.allNodeCarnetDAdresse.edges,
    ...data.allNodeActualites.edges,
    ...data.allNodeEvenements.edges,
    ...data.allNodePage.edges,
  ]
  const filteredNodes = mergedNodes.slice(skip, skip + limit)
  return (
    <Layout message="Résultats">
      <SEO
        title={slugTerm}
        description={
          "Dans cette page, vous découvrez une liste de contenus regroupés par thématique, la thématique est la suivante : " +
          slugTerm
        }
      />
      <ResultsTaxo pageContext={pageContext} resultats={filteredNodes} />
    </Layout>
  )
}

//-----------------------Component---------------------------//

//-----------------------Prop-Types---------------------------//

TaxoThematiquesTemplate.propTypes = {
  data: PropTypes.object.isRequired,
  pageContext: PropTypes.object,
}
//-----------------------Prop-Types---------------------------//

export default TaxoThematiquesTemplate
